module.exports = __webpack_public_path__ + "assets/img/101807.8b265dfb.png";